var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.array)?_c('span',_vm._l((_vm.displayedArray),function(item,i){return _c('span',{key:i},[_vm._v(_vm._s(_vm.i18n ? _vm.$gettext(item, _vm.i18nContext) : item)),(i != _vm.array.length - 1)?_c('span',[_vm._v(", ")]):_vm._e()])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }